import { Injectable, resource } from '@angular/core';
import { categoryData, stammteamData, statusData } from '../../../interfaces/selectData';
import { ThemeService } from '../theme.service';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  statusData = statusData
  categoryData = categoryData

  constructor(public themeService: ThemeService) { }

  //CATEGORY COLOR FOR HOVER COMPONENT
  getCategoryColor(categoryValue: string): string {
    const category = this.categoryData.find(item => item.text === categoryValue);
    return category ? category.color : '#ffffff';
  }
  

  //STATUS COLOR FOR HOVER COMPONENT
  getStatusColor(event: any): string {

    if (!event) {
      return '#ffffff';
    }

    if (event.isTempEvent) {

      if (!event.resourceMeta || !Array.isArray(event.resourceMeta)) {
        return '#ffffff';
      }

      const found = event.resourceMeta.find(
        (resource: { id: any }) => resource.id === event.resource
      );

      if (!found) {
        return '#ffffff';
      }

      const tempEventStatus = this.statusData.find(
        status => status.text === found.status
      );

      return tempEventStatus?.color || '#ffffff';
    }

    const status = this.statusData.find(
      item => item.text === event.status
    );

    return status?.color || '#ffffff';
  }


  //GETS THE CUSTOMER COLOR FOR STAMMTEAMS
  getStammteamColor(event: any): string {
    if (!event?.customer?.length || !event.customer[0]?.color?.trim()) {
      return '#dbdbdbff';
    }
    return event.customer[0].color;
  }


  //BACKGROUND FOR EVENTS WITH COLORED PATTERNS
  getBackground(event: any){
    if(event.resource === "Allgemein") {
       return {"background-color":`#ffeeba`};
    }
    if(['MISSIONEVENT', 'TEAMEVENT', 'MEETINGEVENT', 'NOTBILLABLEEVENT'].includes(event.type)){
      let eventColor = event.color ? event.color : event.color = '#e7e7e7ff';
      if(event && event.isTempEvent){
        const found = event.resourceMeta.find((item: { id: any; }) => item.id === event.resource);
        if(found){
          if(found.status !== 'Gebucht'){
            const status = this.statusData.find(item => item.text === found.status);
            const hex = status?.color?.replace('#', '');
            if (hex?.length === 6) {
              return {"background-color":`#${hex}cc`};
            } else {
              const hex = event?.color?.replace('#', '');
              return {"background-color":`#${hex}cc`};
            }
          }else{
            //if(event.customer && event.customer.length > 0 && event.customer?.[0]?.color){
            //  const hex = event.customer[0].color.replace('#', '');
            //  if (hex.length === 6) {
            //    return {"background-color":`#${hex}99`};
            //  } else {
            //    return {"background-color":`${eventColor}`};
            //  }
            //}else{
              return {"background-color":'#e7e7e7ff'};
            //}
          }
        }
      }else{
        if(event.status !== 'Gebucht'){
        const status = this.statusData.find(item => item.text === event.status);
        const hex = status?.color.replace('#', '');
        if (hex?.length === 6) {
          return {"background-color":`#${hex}cc`};
        } else {
          const hex = eventColor.replace('#', '');
          return {"background-color":`#${hex}cc`}; //VORHER cc
        }
        }else{
          //if(event.customer && event.customer.length > 0 && event.customer?.[0]?.color){
          //  const hex = event.customer[0].color.replace('#', '');
          //  if (hex.length === 6) {
          //    return {"background-color":`#${hex}99`};
          //  } else {
          //    return {"background-color":`${eventColor}`};
          //  }
          //}else{
            return {"background-color":'#e7e7e7ff'};
          //}
        }
      }
      


    }else if(['PRIVATEEVENT', 'HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT', 'MATERNITYPROTECTION', 'NOEVENTS'].includes(event.type)){
      if(event.type === 'PRIVATEEVENT'){
        return {
          'background': 'repeating-linear-gradient(-45deg, #f3f3f3, #f3f3f3 11px, #e5e5e5 11px, #e5e5e5 22px)'
        };
      }
      if(event.type === 'HOLIDAYEVENT'){
        return {
          'filter': 'unset',
          'opacity': '0.8',
          'background': 'repeating-linear-gradient(-45deg, #fbf8ec, #fbf8ec 10px, rgb(255, 249, 170) 10px, rgb(255, 249, 170) 20px)'
        };
      }
      if(event.type === 'MATERNITYPROTECTION'){
        return {
          'filter': 'unset',
          'opacity': '0.8',
          'background': 'repeating-linear-gradient(-45deg, #ffffff, #ffffff 10px, rgb(242, 183, 255) 10px, rgb(242, 183, 255) 20px)'
        };
      }
      if(event.type === 'NOEVENTS'){
        return {
          'filter': 'unset',
          'opacity': '0.8',
          'background-image': `
            repeating-linear-gradient(
              45deg,
              rgb(239, 239, 239) 25%,
              transparent 25%,
              transparent 75%,
              rgb(239, 239, 239) 75%,
              rgb(239, 239, 239)
            ),
            repeating-linear-gradient(
              45deg,
              rgb(239, 239, 239) 25%,
              #ffffff 25%,
              #ffffff 75%,
              rgb(239, 239, 239) 75%,
              rgb(239, 239, 239)
            )
          `,
          'background-position': '0 0, 10px 10px',
          'background-size': '20px 20px'
        };
      }
      if(event.type === 'SICKEVENT'){
        return {  
          'filter': 'unset',
          'opacity': '0.8',
          'background-image': `
            repeating-linear-gradient(
              45deg,
              rgb(255, 190, 253) 25%,
              transparent 25%,
              transparent 75%,
              rgb(255, 190, 252) 75%,
              rgb(255, 190, 252)
            ),
            repeating-linear-gradient(
              45deg,
              rgb(255, 190, 252) 25%,
              #ffffff 25%,
              #ffffff 75%,
              rgb(255, 190, 252) 75%,
              rgb(255, 190, 252)
            )
          `,
          'background-position': '0 0, 10px 10px',
          'background-size': '20px 20px'
        };
      }
      if(event.type === 'ILLNESSREPRESENTATIONEVENT'){
        return {
          'filter': 'unset',
          'opacity': '0.8',
          'background': 'repeating-linear-gradient(-45deg, #fdfffdff, #fdfffdff 10px, rgb(195, 255, 180) 10px, rgb(195, 255, 180) 20px)'
        };
      }
    }else{
      return {'background-color':'#f9f9f9'};
    }
    return {'background-color':'#f9f9f9'};
  }


  //LIGHTENS THE COLORS OF THE TEAMS IN THE CALENDAR BACKGROUND
  lightenColor(hex: string, percent: number): string {
    const isDarkMode = this.themeService.isDarkMode;

    if (!hex) {
      hex = 'FFFFFF';
    }

    hex = hex.replace(/^#/, '');

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    let newR: number;
    let newG: number;
    let newB: number;

    if (isDarkMode) {
      // abdunkeln
      newR = Math.max(0, Math.floor(r * (1 - percent / 100)));
      newG = Math.max(0, Math.floor(g * (1 - percent / 100)));
      newB = Math.max(0, Math.floor(b * (1 - percent / 100)));
    } else {
      // aufhellen
      newR = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
      newG = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
      newB = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
    }

    return `#${newR.toString(16).padStart(2, '0')}${newG
      .toString(16)
      .padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  }
}
